module.exports = __webpack_public_path__ + "img/messages.960292da.svg";